import React from 'react'
import {reduxForm} from 'redux-form'
import {connect} from 'react-redux'
import styles from './auth.scss'
import {isAnEmail} from 'lib/validator'
import cn from 'classnames'
import {changeAuthState, retrievePassword} from 'state/actions'

import i18n from 'lib/i18n'
const _ = i18n('passwordReset')

const validate = values => {
	const errors = {}
	if (!isAnEmail(values.email)) {
		errors.email = _('wrongEmail')
	}
	return errors
}

@reduxForm({
	form: "mail",
	fields: ["email"],
	validate,
	destroyOnUnmount: true,
	touchOnBlur: true,
})
class ResetForm extends React.Component {
	static propTypes = {
		fields: React.PropTypes.object.isRequired,
		handleSubmit: React.PropTypes.func.isRequired,
	}
	touch(field) {
		field.onBlur()
	}
	render() {
		const {fields: {email}, handleSubmit, options, isPhone, goBack} = this.props

		return (
			<div>
				<div className={styles.loginForm}>
					<div className={styles.formImage}>
						<img src={require("resources/easinsure/easinsure-logotype-slogan.svg")}/>
					</div>
					<div className={styles.info}>
						{options.ok
							?
							_('retrieve')
							:
							 _('retrieveMSG')
						}
					</div>
					{!options.ok && <form onSubmit={handleSubmit} method="post" className={styles.form}>
						<div className={styles.formGroup}>
							<label htmlFor="email">{_('email')}</label>
							<input placeholder="email" {...email}/>
						</div>
						{email.touched && email.error && <div className={styles.errorMessage}>
							{email.error}
						</div>}
						<div className={styles.formGroup}>
							<button onClick={handleSubmit} className={cn(styles.submitButton, 'client')}>{_('retrieveBth')}</button>
						</div>
					</form>
					}
				</div>
				{options.ok
					?
						<div className={styles.formGroup}>
							<button onClick={goBack} className={cn(styles.submitButton, 'client')}>{_('passwordResetButton')}</button>
						</div>
					:
						<div className={styles.additionalOption}>
							<a onClick={goBack}>{_('passwordForgotten')}</a>
						</div>
				}
			</div>
		)
	}
}

@connect(state => ({
	options: state.auth.options,
	isPhone: state.responsive.isPhone,
}))
export default class PasswordReset extends React.Component {
	retrievePassword(email) {
		const {dispatch} = this.props
		dispatch(retrievePassword(email))
	}

	goBack() {
		const {dispatch} = this.props
		dispatch(changeAuthState(null))
	}

	render() {
		const {options, isPhone} = this.props
		return (
			<div className={styles.authFormsContainer}>
				<ResetForm
					goBack={() => this.goBack()}
					options={options}
					onSubmit={({email}) => this.retrievePassword(email)}
				/>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./components/auth/passwordReset.jsx